module.exports = __webpack_public_path__ + "img/soln-meta-free.35925883.jpg";